const DIALOG_CLOSE_IGNORE_TIMEOUT = 250;

export default class LayoutSidebarMobileDialogState {
  isHotelDropdownOpen = false;
  shouldIgnoreNextDialogClose = false;
  clearDialogCloseIgnoreTimer: ReturnType<typeof setTimeout> | null = null;

  destroy() {
    this.clearDialogCloseIgnore();
  }

  clearDialogCloseIgnore() {
    this.shouldIgnoreNextDialogClose = false;

    if (this.clearDialogCloseIgnoreTimer) {
      clearTimeout(this.clearDialogCloseIgnoreTimer);
      this.clearDialogCloseIgnoreTimer = null;
    }
  }

  shouldCloseDialog() {
    if (this.isHotelDropdownOpen || this.shouldIgnoreNextDialogClose) {
      this.clearDialogCloseIgnore();
      return false;
    }

    return true;
  }

  handleHotelDropdownEscape() {
    this.shouldIgnoreNextDialogClose = true;

    if (this.clearDialogCloseIgnoreTimer) {
      clearTimeout(this.clearDialogCloseIgnoreTimer);
    }

    this.clearDialogCloseIgnoreTimer = setTimeout(() => {
      this.clearDialogCloseIgnore();
    }, DIALOG_CLOSE_IGNORE_TIMEOUT);
  }

  handleHotelDropdownOpenChange(isOpen: boolean) {
    this.isHotelDropdownOpen = isOpen;
  }

  handleHotelChange() {
    this.clearDialogCloseIgnore();
    this.isHotelDropdownOpen = false;
  }
}
